import { Box, Button, FormControl, Tab, Tabs } from "@mui/material";
import Select from "react-select";
import { useContext, useEffect, useState } from "react";
import Navbar from "../../components/shared/Navbar";
import classes from "../../components/Student/CreateStudentForm.module.css";
import {
  flexBetweenWithItemsCenter,
  flexCenter,
  itemsCenter,
} from "../../utilities/commonStyles/commonStyles";
import {
  fetchDivisions,
  fetchTeacherData,
  getLevels,
} from "../../utilities/const/functions";
import { AuthContext } from "../../utilities/context/AuthContext";
import { useNavigate } from "react-router-dom";
import HistoricalAllAttendanceDivisionClass from "./HistoricalAllAttendanceDivisionClass";
import { reactSelectTheme } from "../../utilities/const/const";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div role="tabpanel" hidden={value !== index} {...other}>
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

const HistoricalAllAttendanceReport = () => {
  const [value, setValue] = useState(0);
  const navigate = useNavigate();
  const { setLoading } = useContext(AuthContext);
  const [divisions, setDivisions] = useState([]);
  const [levels, setLevels] = useState([]);
  const [teachers, setTeachers] = useState([]);
  const [search, setSearch] = useState({
    teacher: null,
  });
  const [searchValue, setSearchValue] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [bulk1, setBulk1] = useState(false);
  // const [bulk2, setBulk2] = useState(false);
  const handleClose = () => {
    setBulk1(false);
    // setBulk2(false);
  };
  const fetchInitData = async () => {
    setDivisions([]);
    setLevels([]);
    setTeachers([]);
    try {
      setLoading(true);
      const levelRes = await getLevels();
      if (!levelRes?.error) {
        setLevels(levelRes?.data);
      }
      const divisionRes = await fetchDivisions();
      if (!divisionRes.error) {
        setDivisions(divisionRes.data);
      }
      const teacherRes = await fetchTeacherData();
      if (!teacherRes?.error) {
        setTeachers(teacherRes?.data);
      }
      setLoading(false);
    } catch (e) {
      console.log(e);
    }
  };

  const getTeacherName = (id) => {
    let name = teachers.filter((e) => {
      return e.id == id;
    });

    return name[0]?.name ?? "NA";
  };
  const getLevelName = (id) => {
    let name = levels.filter((e) => {
      return e.id == id;
    });

    return name[0]?.name ?? "NA";
  };

  // const getDivisionData = async () => {
  //   try {
  //     setLoading(true);
  //     const res = await fetchDivisions();
  //     if (!res.error) {
  //       setDivisions(res.data);
  //       setLoading(false);
  //     } else {
  //       setLoading(false);
  //       window.alert(res.message);
  //     }
  //   } catch (e) {
  //     setLoading(false);
  //     window.alert("Something Went Wrong");
  //     console.log(e);
  //   }
  // };

  useEffect(() => {
    fetchInitData();

    return () => {
      setDivisions([]);
    };
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <Navbar pageTags={["Home", "Attendance Report", "Historical"]} />
      <Box sx={{ py: "50px", backgroundColor: "#F4F7FB", minHeight: "100vh" }}>
        <Box sx={{ px: 5 }}>
          <Box sx={{ ...flexBetweenWithItemsCenter, gap: "30px" }}>
            <Box sx={{ ...itemsCenter, gap: "20px", width: "70%" }}>
              <Box>
                <input
                  type="text"
                  name="name"
                  placeholder="Search By Student Id"
                  value={searchValue}
                  style={{
                    height: "64px",
                    width: "360px",
                    boxShadow: "0px 11px 18px rgba(0, 0, 0, 0.08)",
                    borderRadius: "61px",
                  }}
                  onChange={(e) => {
                    setSearchValue(e.target.value);
                  }}
                  className={classes.formInput}
                />
              </Box>
              <FormControl sx={{ width: 200 }}>
                <Select
                  placeholder="All"
                  value={
                    teachers.find((obj) => obj.id === search.teacher) ?? null
                  }
                  theme={reactSelectTheme}
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      height: "42px",
                    }),
                  }}
                  options={teachers
                    .slice()
                    .sort((a, b) => a.name.localeCompare(b.name))}
                  getOptionLabel={(options) => options.name}
                  getOptionValue={(option) => option.id}
                  onChange={(e) => {
                    setSearch({ teacher: e.id });
                  }}
                />
              </FormControl>

              <Button
                onClick={() => {
                  setInputValue(null);
                  setSearch({ teacher: null });
                }}
                sx={{
                  // background: "#FFFFFF",
                  // boxShadow: "2px 2px 8px rgba(0, 0, 0, 0.25)",
                  borderRadius: "6px",
                  padding: "5px 10px",
                  width: "max-content",
                  color: (theme) => theme.palette.secondary.main,
                  "&:hover": {
                    background: "#FFFFFF",
                  },
                }}
              >
                Clear Filter
              </Button>
            </Box>
            <Box sx={{ ...flexCenter, gap: "5%", justifyContent: "flex-end" }}>
              <Button
                onClick={() => {
                  navigate(-1);
                }}
                variant="outlined"
                // sx={{
                //   background: "#FFFFFF",
                //   boxShadow: "2px 2px 8px rgba(0, 0, 0, 0.25)",
                //   borderRadius: "6px",
                //   padding: "5px 10px",
                //   color: (theme) => theme.palette.secondary.main,
                //   "&:hover": {
                //     background: "#FFFFFF",
                //   },
                // }}
              >
                Ongoing Attendance
              </Button>
            </Box>
          </Box>

          <Box sx={{ mt: "30px" }}>
            <Tabs
              variant="fullWidth"
              TabIndicatorProps={{
                style: {
                  height: "0px",
                },
              }}
              TabScrollButtonProps={{
                style: {
                  textTransform: "none",
                  fontStyle: "normal",
                },
              }}
              value={value}
              onChange={handleChange}
              textColor="primary"
              indicatorColor="primary"
              // sx={{  }}
            >
              {divisions
                ?.sort((a, b) => {
                  return a.name > b.name ? 1 : -1;
                })
                .map((item, index) => (
                  <Tab
                    key={item.id}
                    sx={{
                      fontSize: "16px",
                      borderRadius: "20px 20px 0px 0px",
                      backgroundColor: index == value ? "#fff" : "transparent",
                      mx: "12px",
                    }}
                    label={item.name}
                  />
                ))}
            </Tabs>
            {/* </Box> */}
            {divisions
              ?.sort((a, b) => {
                return a.name > b.name ? 1 : -1;
              })
              .map((item, index) => (
                <TabPanel
                  sx={{ py: 1 }}
                  key={item.id}
                  value={value}
                  index={index}
                >
                  <HistoricalAllAttendanceDivisionClass
                    search={search}
                    searchValue={searchValue}
                    getTeacherName={getTeacherName}
                    getLevelName={getLevelName}
                    data={item}
                  />
                </TabPanel>
              ))}
            {/* {[1, 2].map((item) => (
              <AllAttendanceTable />
            ))} */}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default HistoricalAllAttendanceReport;
